const initialState = {
  returnItems: []
};

export default function returnItemsUserScreenshotsReducer(state = initialState, action) {
  const { type, data = [] } = action;
  switch (type) {
    case 'UPDATE_RETURN_ITEMS_USER_SCREENSHOTS':
      return {
        ...state,
        returnItems: [...data]
      };

    case 'RESET_RETURN_ITEMS_USER_SCREENSHOTS':
      return {
        ...state,
        returnItems: []
      };

    default:
      return state;
  }
}
